import { render } from "./IDPSkillPillar.vue?vue&type=template&id=90a8c54a&scoped=true"
import script from "./IDPSkillPillar.vue?vue&type=script&lang=js"
export * from "./IDPSkillPillar.vue?vue&type=script&lang=js"

import "./IDPSkillPillar.vue?vue&type=style&index=0&id=90a8c54a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a8c54a"]])

export default __exports__